<p-table #dt styleClass="p-datatable-responsive-demo" [value]="venueSvc.ooCanvases[canvasIndex].menuItems" dataKey="menuItemKey"
    [globalFilterFields]="['ooMenuItem.name','displayName','description']">
    <ng-template pTemplate="caption">
        <div class="table-header d-flex">
            <div class="flex-grow-1 me-2">
                <span class="p-float-label p-input-icon-left m-2 w-100">
                    <i class="pi pi-search "></i>
                    <input pInputText class="w-100" id="globalSearch" name="globalSearch" style="width: 100%"
                        type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" />
                    <label for="globalSearch">Search included items...</label>
                </span>
            </div>
            <div class="ms-auto">
                <p-button pRipple styleClass="p-button-raised p-button-primary m-2" (click)="newItem()">
                    <ng-template pTemplate="content">
                        <div class="d-flex justify-content-center">
                            <fa-icon [icon]='["far","plus"]' size="lg" class="ms-1 me-2"></fa-icon>
                            Add Included Item
                        </div>
                    </ng-template>
                </p-button>
            </div>
        </div>
    </ng-template>
    <ng-template pTemplate="header" #header>
        <tr>
            <th>
                <div class="d-flex flex-column">
                    <div>
                        Item Name
                    </div>
                    <div>
                        Display Name
                    </div>
                </div>
            </th>
            <th>
                Description
            </th>
            <th>
                No Price
            </th>
            <th>
                Lite Price
            </th>
            <th>
                Extra Price
            </th>
            <th>
            </th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" #body let-rec let-rowIndex="rowIndex">
        <tr>
            <td>
                <span class="p-column-title">Item Name/Display Name</span>
                <div class="d-flex flex-column">
                    <div>{{rec.ooMenuItem.name}}</div>
                    <div>{{rec.displayName}}</div>
                </div>
            </td>
            <td>
                <span class="p-column-title">Description</span>
                <span class="descriptionText">{{rec.description}}</span>
            </td>
            <td >
                <span class="p-column-title">No Price</span>
                {{venueSvc.menuItemGetPriceFromNumber(rec.ooMenuItem, rec.priceNumberNo) | currency}}
            </td>
            <td>
                <span class="p-column-title">Lite Price</span>
                {{venueSvc.menuItemGetPriceFromNumber(rec.ooMenuItem, rec.priceNumberLite) | currency}}
            </td>
            <td>
                <span class="p-column-title">Extra Price</span>
                {{venueSvc.menuItemGetPriceFromNumber(rec.ooMenuItem, rec.priceNumberExtra) | currency}}
            </td>
            <td style="text-align: right;">
                <p-button pRipple styleClass="p-button-raised p-button-secondary  m-2"
                    (click)="newRecord = false; selectedCanvasMenuItem = rec;">
                    <ng-template pTemplate="content">
                        <fa-icon [icon]='["far","pencil"]' size="lg" class="ms-1"></fa-icon>
                    </ng-template>
                </p-button>
                <p-button pRipple styleClass="p-button-raised p-button-danger  m-2"
                    (click)="removeIncludedItem(rec)">
                    <ng-template pTemplate="content">
                        <fa-icon [icon]='["far","trash"]' size="lg" class="ms-1"></fa-icon>
                    </ng-template>
                </p-button>
            </td>
        </tr>
    </ng-template>
</p-table>

<app-canvas-menu-item-createEdit *ngIf="selectedCanvasMenuItem" [newRecord]="newRecord"
    [ooCanvasMenuItem]="selectedCanvasMenuItem" [sourceComponent]="'canvas'" [venueKey]="venueSvc.venueKey"
    (ooCanvasMenuItemEmitter)="selectedCanvasMenuItem = undefined"
    (closeEmitter)="selectedCanvasMenuItem = undefined; newRecord = false;"></app-canvas-menu-item-createEdit>